import React from "react";
import Container from 'react-bootstrap/Container';

export function ContactInfo() {
  return (
    <div className='d-flex flex-column align-items-center'>
      {/* <h2 className='fs-1 mb-3 text-uppercase fw-bold'>Where To Find Us</h2> */}
      <h2 className='fs-1 mb-3 fw-bold'>Where To Find Us</h2>
      {/* <p className='mb-5'>47 Baker Street, London LD1 0ND</p> */}

      <Container fluid>
        <div className='contact-info'>
          <ul>
            <li><i className='fas fa-address fs-5'>DongGuang City, GuangDong Province, China</i></li>
            <li><i className='fas fa-envelope fs-5'></i>hello@domain.com</li>
            <li><i className='fas fa-phonefs-5'></i>000-000-0000</li>
            <li><i className='fas fa-map-marker-alt fs-5'></i>GuangDong, China</li>
          </ul>
        </div>
      </Container >

      <div className='google-map'>
        {/* <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14048.211570060965!2d-0.1228208876550775!3d51.505942908931324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2suk!4v1481805868782"></iframe> */}
        <iframe title="map" src="https://www.google.com/maps"></iframe>
      </div>

      <h3>Working Hours</h3>
      <p className='m-1 fs-5'>Mon - Sat: 08:00 -1 8:00</p>
    </div >
  )
}